<div class="currency-conversion-msg" ng-show="domesticPayment.location=='hr'">
  <div class="app-white-card">
    <div class="row">
      <div class="col-sm-1">
        <div class="currency-check-icon">
          <i class="zmdi zmdi-check zmdi-hc-3x"></i>
        </div>
      </div>
      <div class="col-sm-11">
        <h3 translate="internalTransfer.transferComplete"></h3>
        <div class="f-16">
          <span translate="internalTransfer.successfullyTransfer"></span>
          <span>
            {{domesticPaymentCro.insertedPaymentObject.amount | number:2}}
            {{domesticPaymentCro.insertedPaymentObject.currencySymbol}}
          </span>
          <span translate="payments.fromAcc">from</span>
          <span>{{domesticPaymentCro.insertedPaymentObject.fromAccountNumber}}</span>
          <span translate="payments.toAcc">to</span>
          <span>{{domesticPaymentCro.insertedPaymentObject.toAccountNumber}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-t-20">
    <div class="col-sm-4">
      <a href="" data-ng-click="">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>
      </a>
    </div>
  </div>
</div>


<div class="currency-conversion-msg" ng-show="domesticPayment.location=='sr'">
  <div class="app-white-card">
    <div class="row">
      <div class="col-sm-1">
        <div class="currency-check-icon">
          <i class="zmdi zmdi-check zmdi-hc-3x"></i>
        </div>
      </div>
      <div class="col-sm-11">
        <h3 translate="internalTransfer.transferComplete"></h3>
        <div class="f-16">
          <span translate="internalTransfer.successfullyTransfer"></span>
          <span>
            {{domesticPaymentSrb.insertedPaymentObject.amount | number:2}}
            {{domesticPaymentSrb.insertedPaymentObject.currencySymbol}}
          </span>
          <span translate="payments.fromAcc">from</span>
          <span>{{domesticPaymentSrb.insertedPaymentObject.fromAccountNumber}}</span>
          <span translate="payments.toAcc">to</span>
          <span>{{domesticPaymentSrb.insertedPaymentObject.toAccountNumber}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-t-20">
    <div class="col-sm-4">
      <a href="" data-ng-click="">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>
      </a>
    </div>
  </div>
</div>

<div class="currency-conversion-msg" ng-show="domesticPayment.location=='mne'">
  <div class="app-white-card">
    <div class="row">
      <div class="col-sm-1">
        <div class="currency-check-icon">
          <i class="zmdi zmdi-check zmdi-hc-3x"></i>
        </div>
      </div>
      <div class="col-sm-11">
        <h3 translate="internalTransfer.transferComplete"></h3>
        <div class="f-16">
          <span translate="internalTransfer.successfullyTransfer"></span>
          <span>
            {{domesticPaymentMne.insertedPaymentObject.amount | number:2}}
            {{domesticPaymentMne.insertedPaymentObject.currencySymbol}}
          </span>
          <span translate="payments.fromAcc">from</span>
          <span>{{domesticPaymentMne.insertedPaymentObject.fromAccountNumber}}</span>
          <span translate="payments.toAcc">to</span>
          <span>{{domesticPaymentMne.insertedPaymentObject.toAccountNumber}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row m-t-20">
    <div class="col-sm-4">
      <a href="" data-ng-click="">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>
      </a>
    </div>
  </div>
</div>

<div class="currency-conversion-msg" ng-show="domesticPayment.location=='sl'">
  <div class="app-white-card">
    <div class="row">
      <div class="col-sm-1">
        <div class="currency-check-icon">
          <i class="zmdi zmdi-check zmdi-hc-3x"></i>
        </div>
      </div>
      <div class="col-sm-11">
        <h3 translate="internalTransfer.transferComplete"></h3>
        <div class="f-16">
          <span translate="internalTransfer.successfullyTransfer"></span>
          <span>
            {{domesticPaymentSlo.insertedPaymentObject.amount | number:2}}
            {{domesticPaymentSlo.insertedPaymentObject.currencySymbol}}
          </span>
          <span translate="payments.fromAcc">from</span>
          <span>{{domesticPaymentSlo.insertedPaymentObject.fromAccountNumber}}</span>
          <span translate="payments.toAcc">to</span>
          <span>{{domesticPaymentSlo.insertedPaymentObject.toAccountNumber}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-t-20">
    <div class="col-sm-4">
      <a href="" data-ng-click="">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.saveAsTemplate"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ng-click="internalTransfer.backToInternalTransfer();">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="internalTransfer.makeAnotherPayment"></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a href="" data-ui-sref="payments.paymentsAndTransferOverview">
        <span class="money-exchange-icon"><i class="zmdi zmdi-money-box zmdi-hc-2x"></i></span>
        <span class="f-14 bold-font" translate="currencyConversion.goToPayments"></span>
      </a>
    </div>
  </div>
</div>
